import axios from 'axios'
import { config } from '../Config/config'

const cardService = {

    getAllFilter: (filter) => {
        const result = axios.post(config.apiUrl + '/cardId', filter)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    addData: (data) => {
        const result = axios.post(config.apiUrl + '/card', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })

            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getById: (id) => {
        const result = axios.get(config.apiUrl + '/cardById/' + id)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })

            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },


    softDeleteData: (data) => {
        const result = axios.put(config.apiUrl + '/cardHapus', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })

            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },



    countData: (filter) => {
        const result = axios.post(config.apiUrl + '/countCard', filter)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },


    dupeDataCard: (card_number) => {
        const result = axios.get(config.apiUrl + '/card/' + card_number)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    }

}

export default cardService